import styled from "styled-components";
import { Divider as RCLDivider } from "discover.medical.react-component-library";
import { Filters as FiltersComponent } from "./Filters";
import { Alert as AlertComponent } from "./Alert";

export const StyledSpan = styled.span``;

export const Divider = styled(RCLDivider)`
  margin-bottom: ${({ theme }) => theme.space.md};
`;

export const Alert = styled(AlertComponent)`
  margin-bottom: ${({ theme }) => theme.space.lg};
`;

export const Filters = styled(FiltersComponent)`
  margin-bottom: ${({ theme }) => theme.space.md};
`;

export const FilterDivider = styled(RCLDivider)`
  margin: 0 ${({ theme }) => theme.space.sm};
`;

export const StyledTextContainer = styled.div``;

export const StyledAlgorithmLogo = styled.img`
  min-width: 40px;
  width: 40px;
  height: 40px;
  margin: ${({ theme }) => theme.space.xs} ${({ theme }) => theme.space.sm} 0 0;
`;
